export const parseHost = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./i, "").toLowerCase();
  } catch (e) {
    return "";
  }
};

export const isExternal = (referrer, currentHost) => {
  const host = parseHost(referrer);
  return host !== "" && host !== currentHost;
};

export const readAttrCookie = (cookieString, name = "od_attr") => {
  const parts = ("; " + (cookieString || "")).split("; " + name + "=");
  if (parts.length !== 2) return null;
  try {
    return JSON.parse(decodeURIComponent(parts.pop().split(";").shift()));
  } catch (e) {
    return null;
  }
};

// Pure: given the current page context, return the first-touch payload to
// persist, or null if nothing should be written (first-touch already locked).
export const computeFirstTouch = ({ existingCookie, referrer, href, now }) => {
  if (existingCookie) return null;

  let currentHost = "";
  let params = new URLSearchParams();
  try {
    const url = new URL(href);
    currentHost = url.hostname.replace(/^www\./i, "").toLowerCase();
    params = url.searchParams;
  } catch (e) {
    // href unparseable — keep empty host/params
  }

  return {
    r: isExternal(referrer, currentHost) ? referrer : "",
    s: params.get("utm_source") || "",
    m: params.get("utm_medium") || "",
    c: params.get("utm_campaign") || "",
    f: params.get("fbclid") || "",
    u: href || "",
    t: now
  };
};

export const fbclidFromHref = (value) => {
  try {
    return new URL(value).searchParams.get("fbclid") || "";
  } catch (e) {
    return "";
  }
};

export const CLICK_ID_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export const resolveMetaClickId = ({ href, attrCookie, embedHref, now }) => {
  const fromLiveUrl = fbclidFromHref(href);
  if (fromLiveUrl) return fromLiveUrl;

  const pageHost = parseHost(href);
  if (pageHost !== "" && pageHost === parseHost(embedHref || "")) return "";

  if (!attrCookie) return "";
  if (now != null && attrCookie.t != null) {
    const clickedAt = Number(attrCookie.t);
    if (!Number.isFinite(clickedAt)) return "";
    if (clickedAt > now) return "";
    if (now - clickedAt > CLICK_ID_MAX_AGE_MS) return "";
  }

  return attrCookie.f || fbclidFromHref(attrCookie.u || "");
};
